import type { ExternalPostingStatus, RevenueItem } from "./types";

// Wire DTO for one revenue row of the reservation model response. Dates arrive as strings;
// ExternalPostingStatus is the per-date RV-journal posting-status carrier populated by the
// tenant's enrichment seam (null/absent when the tenant has no posting integration).
export interface RevenueItemDto {
    DateStatus: "LOCKED" | "CURRENT" | "FUTURE";
    CreatedDate: string;
    EffectiveDate: string;
    Account: string;
    Description: string;
    Amount: number;
    ExternalPostingStatus?: ExternalPostingStatus | null;
}

// Hydrates a revenue-row DTO into the client model shape. Kept as a pure leaf function (S37) so
// the field set is unit-testable: the payments/refunds hydration carried ExternalPostingStatus
// through while this mapping silently dropped it, rendering blank posting-status cells.
export function hydrateRevenueItem(r: RevenueItemDto): RevenueItem {
    return {
        DateStatus: r.DateStatus,
        CreatedDate: new Date(r.CreatedDate),
        EffectiveDate: new Date(r.EffectiveDate),
        Account: r.Account,
        Description: r.Description,
        Amount: r.Amount,
        ExternalPostingStatus: r.ExternalPostingStatus ?? null,
    };
}
